import * as React from 'react';
import Alert, { AlertCategoryEnum } from '../misc/components/Alert';

export interface ErrorBoundaryState {
    error: Error;
    errorInfo: React.ErrorInfo;
}

declare var rootUrl: string;

export class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, ErrorBoundaryState> {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            errorInfo: null
        };
    }

    render() {
        if (this.state.errorInfo) {
            return (
                <Alert show={true} category={AlertCategoryEnum.Danger}>
                    Unfortunately an error has occurred.  The error details have been recorded. We apologize for any inconvenience caused. Please let us know by contacting Vitalograph Support Services
                </Alert>
            );
        }

        return this.props.children;
    }
}
